import type { Movimentacao } from '../../api/movimentacoes.js';
import type { Pagina } from '../../api/paginacao.js';
import { intervaloDaPagina, totalDePaginas } from '../../api/paginacao.js';
import { Paginacao } from '../../componentes/Paginacao.js';
import { Tabela } from '../../componentes/Tabela.js';
import type { Coluna } from '../../componentes/Tabela.js';
import { AutorDaMovimentacao } from './AutorDaMovimentacao.js';
import { CaminhoDeDepositos } from './CaminhoDeDepositos.js';
import { ChipDeFamilia } from './ChipDeFamilia.js';
import { formatarDataHora } from '../../componentes/datas.js';
import { rotuloDoTipo } from './formato.js';
import './TrilhaDoProduto.css';

const COLUNAS: readonly Coluna<Movimentacao>[] = [
  {
    chave: 'registradoEm',
    rotulo: 'Horário',
    largura: '150px',
    celula: (movimentacao) => (
      <span className="trilha__horario">{formatarDataHora(movimentacao.registradoEm)}</span>
    ),
  },
  {
    chave: 'tipo',
    rotulo: 'Tipo',
    largura: '170px',
    celula: (movimentacao) => rotuloDoTipo(movimentacao.tipo),
  },
  {
    chave: 'caminho',
    rotulo: 'Origem → destino',
    celula: (movimentacao) => (
      <CaminhoDeDepositos
        depositoOrigem={movimentacao.depositoOrigem}
        filialOrigem={movimentacao.filialOrigem}
        depositoDestino={movimentacao.depositoDestino}
        filialDestino={movimentacao.filialDestino}
      />
    ),
  },
  {
    chave: 'quantidade',
    rotulo: 'Qtd.',
    largura: '110px',
    alinhamento: 'direita',
    celula: (movimentacao) => <span className="trilha__quantidade">{movimentacao.quantidade}</span>,
  },
  {
    chave: 'familia',
    rotulo: 'Movimentação',
    largura: '180px',
    celula: (movimentacao) => <ChipDeFamilia movimentacao={movimentacao} />,
  },
  {
    chave: 'autor',
    rotulo: 'Operador',
    largura: '18%',
    celula: (movimentacao) => <AutorDaMovimentacao autor={movimentacao} />,
  },
];

type Props = {
  readonly pagina: Pagina<Movimentacao>;
  readonly aoIrPara: (pagina: number) => void;
};

/**
 * Trilha cronológica do produto (UC11 passo 3): cada depósito, o operador
 * responsável, o horário e o tipo da movimentação.
 *
 * Vem paginada do servidor. Um produto de giro alto passa das 5.000
 * movimentações que o RNF-006 exige responder em 3s — trazer tudo para cortar
 * no navegador seria justamente o que quebra esse prazo.
 */
export function TrilhaDoProduto({ pagina, aoIrPara }: Props) {
  return (
    <Tabela
      itens={pagina.itens}
      colunas={COLUNAS}
      chaveDe={(movimentacao) => movimentacao.id}
      descricao="Trilha do produto"
      rodape={
        <Paginacao
          intervalo={intervaloDaPagina(pagina, 'movimentação', 'movimentações')}
          pagina={pagina.pagina}
          totalPaginas={totalDePaginas(pagina)}
          aoIrPara={aoIrPara}
        />
      }
    />
  );
}
